import httpClient from './httpClient';
import type {
  UserListItem,
  UserDetail,
  CreateUserRequest,
  UpdateUserRequest,
  UserFilters,
  AuditLogItem,
  AuditLogFilters,
} from '@/types/admin';
import type { PaginatedResult } from '@/types';

export async function getUsers(mdFilters: UserFilters): Promise<PaginatedResult<UserListItem>> {
  const mdParams: Record<string, string | number | boolean> = {
    page: mdFilters.page,
    pageSize: mdFilters.pageSize,
  };
  if (mdFilters.search) mdParams.search = mdFilters.search;
  if (mdFilters.role) mdParams.role = mdFilters.role;
  if (mdFilters.isActive !== undefined) mdParams.isActive = mdFilters.isActive;

  const mdResponse = await httpClient.get<PaginatedResult<UserListItem>>('/users', { params: mdParams });
  return mdResponse.data;
}

export async function getUserById(mdId: string): Promise<UserDetail> {
  const mdResponse = await httpClient.get<UserDetail>(`/users/${mdId}`);
  return mdResponse.data;
}

export async function createUser(mdData: CreateUserRequest): Promise<UserDetail> {
  const mdResponse = await httpClient.post<UserDetail>('/users', mdData);
  return mdResponse.data;
}

export async function updateUser(mdData: UpdateUserRequest): Promise<UserDetail> {
  const mdResponse = await httpClient.put<UserDetail>(`/users/${mdData.id}`, mdData);
  return mdResponse.data;
}

export async function toggleUserActive(mdId: string): Promise<void> {
  await httpClient.post(`/users/${mdId}/toggle-active`);
}

export async function resetUserPassword(mdId: string): Promise<{ newPassword: string }> {
  const mdResponse = await httpClient.post<{ newPassword: string }>(`/users/${mdId}/reset-password`);
  return mdResponse.data;
}

export async function getRoles(): Promise<string[]> {
  const mdResponse = await httpClient.get<string[]>('/users/roles');
  return mdResponse.data;
}

export async function getAuditLogs(mdFilters: AuditLogFilters): Promise<PaginatedResult<AuditLogItem>> {
  const mdParams: Record<string, string | number> = {
    page: mdFilters.page,
    pageSize: mdFilters.pageSize,
  };
  if (mdFilters.search) mdParams.search = mdFilters.search;
  if (mdFilters.entityName) mdParams.entityName = mdFilters.entityName;
  if (mdFilters.userId) mdParams.userId = mdFilters.userId;
  if (mdFilters.dateFrom) mdParams.dateFrom = mdFilters.dateFrom;
  if (mdFilters.dateTo) mdParams.dateTo = mdFilters.dateTo;

  const mdResponse = await httpClient.get<PaginatedResult<AuditLogItem>>('/audit-logs', { params: mdParams });
  return mdResponse.data;
}
